module.exports = __webpack_public_path__ + "static/media/GemischteGruppen02.4b08bcc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/GemischteGruppen02.jpg
// module id = 336
// module chunks = 0